var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "w-full p-7" };
var _hoisted_2 = { class: "text-3xl text-center font-bold" };
var _hoisted_3 = {
    key: 0,
    class: "mt-5 text-gray-400 flex justify-center items-center"
};
var _hoisted_4 = { class: "font-normal" };
var _hoisted_5 = { class: "mt-5 flex items-center justify-between" };
var _hoisted_6 = { class: "font-medium" };
var _hoisted_7 = { class: "font-medium" };
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import analytics from '@common/utils/Analytics/Analytics';
import Auth from '@common/modules/auth';
import { apiErrorsHandle } from '@common/utils/Helpers/Helpers';
import { AuthModalStore, CoreStore } from '@student/modules/store';
import { AuthRoles } from '@common/interfaces/utils';
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import EButton from '@common/ui/EButton.vue';
import EInputField from '@common/ui/EForm/fields/EInputField.vue';
import { planFeatures } from '@common/utils/Plans';
import { canUseFeature } from '@common/modules/school';
import getClientFingerprint from '@common/utils/ClientFingerprint';
import ELabel from '@common/ui/ELabel.vue';
import ECheckboxField from '@common/ui/EForm/fields/ECheckboxField.vue';
import EIcon from '@common/ui/EIcon.vue';
import { storageSession } from '@common/utils/Storage/Storage';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AuthModalLogin',
    setup: function (__props) {
        var _this = this;
        var t = useI18n().t;
        var loading = ref(false);
        var _a = useForm({
            validationSchema: toTypedSchema(z.object({
                emailOrLogin: z.string().min(1, t('login.validation.emailOrLogin')),
                password: z.string().min(1, t('login.validation.password')),
                rememberMe: z.boolean()
            })),
            initialValues: {
                emailOrLogin: '',
                password: '',
                rememberMe: true,
            }
        }), values = _a.values, resetForm = _a.resetForm, setValues = _a.setValues, handleSubmit = _a.handleSubmit;
        var school = computed(function () { return CoreStore.school; });
        var passwordRecoveryEmail = computed(function () { return AuthModalStore.email; });
        var isEmail = computed(function () { return values.emailOrLogin.includes('@'); });
        watch(passwordRecoveryEmail, function (value) {
            setValues({
                emailOrLogin: value
            });
        });
        var submitForm = handleSubmit(function (values, ctx) { return __awaiter(_this, void 0, void 0, function () {
            var res, result, currentPath, isSaveCurrentLocation, isMustReload, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loading.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Auth.login({
                                email: values.emailOrLogin.trim(),
                                password: values.password.trim(),
                            })];
                    case 2:
                        res = _a.sent();
                        result = res.data;
                        currentPath = window.location.pathname;
                        isSaveCurrentLocation = currentPath.includes('course') || currentPath.includes('stream');
                        if (isSaveCurrentLocation) {
                            storageSession.set('routeToRedirectAfterAuth', {
                                fullPath: currentPath,
                            });
                        }
                        analytics.track('$authorized', { '$email': values.emailOrLogin, });
                        isMustReload = (result.user.role && result.user.role !== AuthRoles.ROLE_STUDENT) || currentPath.includes('course');
                        if (isMustReload) {
                            Auth.restoreSavedLocation(true);
                        }
                        else {
                            Auth.restoreSavedLocation(false, null, true);
                        }
                        AuthModalStore.hide();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        apiErrorsHandle(err_1, {
                            'USER_NOT_FOUND': t('login.errors.userNotFound'),
                            'ERROR_AUTH': t('login.errors.invalidCredentials')
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        var emailUpdate = function (email) {
            AuthModalStore.email = email;
        };
        var passwordForgot = function () {
            AuthModalStore.goPasswordRecovery();
        };
        var goRegister = function () {
            AuthModalStore.goRegister();
        };
        var goMosruProvider = function () { return __awaiter(_this, void 0, void 0, function () {
            var fingerPrint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientFingerprint()];
                    case 1:
                        fingerPrint = _a.sent();
                        location.href = "/api/openid/mosru-auth?fingerprint=".concat(fingerPrint, "&returnUrl=").concat(location.href);
                        return [2 /*return*/];
                }
            });
        }); };
        var canUseMosruAuth = canUseFeature(planFeatures.AUTH_PROVIDER_MOSRU);
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('login.title')), 1),
                (school.value.allowSelfRegister)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('login.noAccount')), 1),
                        _createVNode(EButton, {
                            class: "text-primary hover:underline inline ml-1",
                            size: "nosize",
                            type: "text",
                            onClick: goRegister
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('login.register')), 1)
                            ]; }),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(ELabel, {
                    label: _unref(t)('login.emailOrLogin'),
                    class: "mt-5",
                    weight: "medium"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EInputField, {
                            placeholder: _unref(t)('login.emailOrLoginPlaceholder'),
                            plugins: ['trim'],
                            type: isEmail.value ? 'email' : 'text',
                            name: "emailOrLogin",
                            size: "large",
                            theme: "gray",
                            autocomplete: "",
                            onChange: emailUpdate,
                            onKeyup: _withKeys(_unref(submitForm), ["enter"])
                        }, null, 8, ["placeholder", "type", "onKeyup"])
                    ]; }),
                    _: 1
                }, 8, ["label"]),
                _createVNode(ELabel, {
                    label: _unref(t)('login.password'),
                    class: "mt-5",
                    weight: "medium"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EInputField, {
                            plugins: ['trim'],
                            name: "password",
                            placeholder: "••••••••",
                            size: "large",
                            theme: "gray",
                            type: "password",
                            autocomplete: "",
                            onKeyup: _withKeys(_unref(submitForm), ["enter"])
                        }, null, 8, ["onKeyup"])
                    ]; }),
                    _: 1
                }, 8, ["label"]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(ECheckboxField, { name: "rememberMe" }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('login.rememberMe')), 1)
                        ]; }),
                        _: 1
                    }),
                    _createVNode(EButton, {
                        class: "font-medium hover:underline hover:text-green shrink-0",
                        size: "nosize",
                        type: "text",
                        onClick: passwordForgot
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('login.forgotPassword')), 1)
                        ]; }),
                        _: 1
                    })
                ]),
                _createVNode(EButton, {
                    loading: loading.value,
                    class: "mt-7 w-full",
                    size: "large",
                    type: "primary",
                    onClick: _unref(submitForm)
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode(_toDisplayString(_unref(t)('login.submit')), 1)
                    ]; }),
                    _: 1
                }, 8, ["loading", "onClick"]),
                (_unref(canUseMosruAuth))
                    ? (_openBlock(), _createBlock(EButton, {
                        key: 1,
                        class: "w-full mt-5",
                        size: "large",
                        type: "green-alt",
                        onClick: goMosruProvider
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(EIcon, {
                                class: "w-5 h-5 mr-2",
                                icon: "logo-mosru"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('login.mosruLogin')), 1)
                        ]; }),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
